"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeHelper = void 0;

var _reduxActions = require("redux-actions");

var store;
var createRootReducer;
var reducersToAdd;

function init(reduxStore, rootReducerCreator) {
  store = reduxStore;
  createRootReducer = rootReducerCreator;
  merge();
}

function getStore() {
  return store;
}

function getState() {
  return store ? store.getState() : undefined;
}

function dispatch(typeOrAction, payload) {
  if (store) {
    var action = typeof typeOrAction === 'string' ? (0, _reduxActions.createAction)(typeOrAction)(payload) : typeOrAction;
    store.dispatch(action);
  }
}

function mergeTopReducer(reducer) {
  if (reducer.sliceName !== reducer.slicePath) {
    throw new Error("'".concat(reducer.slicePath, "' is not a Top Reducer"));
  }

  reducersToAdd = reducersToAdd || {};
  reducersToAdd[reducer.sliceName] = reducer;
  merge();
  return reducer;
}

function merge() {
  if (!store) {
    return;
  }

  if (store.asyncReducers === undefined) {
    store.asyncReducers = {};
  }

  if (reducersToAdd) {
    Object.keys(reducersToAdd).forEach(function (sliceName) {
      var reducer = reducersToAdd[sliceName];

      if (sliceName in store.asyncReducers) {
        var mod = module;

        if (process.env.NODE_ENV === 'development' && mod.hot) {
          store.asyncReducers[sliceName] = reducer;
        } else {
          // eslint-disable-next-line no-console
          console.error("TopReducer '".concat(sliceName, "' already exists!"));
        }
      } else {
        store.asyncReducers[sliceName] = reducer;
      }
    });
    reducersToAdd = undefined;
    store.replaceReducer(createRootReducer(store.asyncReducers));
  }
}

var storeHelper = {
  dispatch: dispatch,
  init: init,
  getStore: getStore,
  getState: getState,
  mergeTopReducer: mergeTopReducer
};
exports.storeHelper = storeHelper;